/* eslint-disable react/button-has-type */
import React from 'react';

type ButtonProps = {
  content: string;
  className?: string;
};

function Tooltip({ content, className }: ButtonProps) {
  return (
    <span
      data-after={content}
      className={`tooltip hover:after:block after:content-[attr(data-after)] ${className}`}
    />
  );
}

Tooltip.defaultProps = {
  className: '',
};

export default Tooltip;
